import { cn } from '@/shared/lib/utils';

/**
 * RDS Pop-Up 공통 스타일.
 * @see https://www.figma.com/design/wcgji99mZRPIytCZDjwqxe/RDS-v1.0?node-id=2420-3921
 */
export const popupOverlayClassName = cn(
  'fixed inset-0 z-50 bg-[#131927]/40',
  'data-[state=open]:animate-in data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
);

/** 확인용 팝업 폭 (Figma 328) · radius 40 */
export const popupContentClassName = cn(
  // 모바일에서 화면 양옆 여백 16px 확보
  'fixed left-[50%] top-[50%] z-50 grid w-[calc(100%-2rem)] max-w-[328px]',
  'translate-x-[-50%] translate-y-[-50%]',
  'gap-6 overflow-hidden rounded-40 border-[1.5px] border-ruda-grey-100',
  'bg-white px-6 pb-4 pt-12 text-ruda-text-primary',
  'shadow-[0_6px_14px_-6px_rgba(19,25,39,0.12),0_10px_32px_-4px_rgba(19,25,39,0.1)]',
  'duration-200',
  'data-[state=open]:animate-in data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
  'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
);

/** 폼 등 넓은 다이얼로그 — 동일 셸, 폭만 확장 · radius 40 */
export const dialogContentClassName = cn(
  // 모바일: 양옆 여백 16px + 화면보다 길면 다이얼로그 안에서 세로 스크롤
  'fixed left-[50%] top-[50%] z-50 grid w-[calc(100%-2rem)] max-w-lg',
  'max-h-[calc(100dvh-2rem)] overflow-y-auto',
  'translate-x-[-50%] translate-y-[-50%]',
  'gap-6 rounded-40 border-[1.5px] border-ruda-grey-100',
  'bg-white px-6 py-8 text-ruda-text-primary',
  'shadow-[0_6px_14px_-6px_rgba(19,25,39,0.12),0_10px_32px_-4px_rgba(19,25,39,0.1)]',
  'duration-200',
  'data-[state=open]:animate-in data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
  'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
);

export const popupHeaderClassName =
  'flex flex-col items-center gap-1 space-y-0 text-center';

export const popupTitleClassName =
  'text-base font-semibold leading-6 tracking-tight text-ruda-text-primary';

export const popupDescriptionClassName =
  'text-sm font-normal leading-[22px] tracking-tight text-[#6d717f]';

/** Horizontal Buttons — Cancel(grey) + Confirm(dark), flex-1 · radius 16 */
export const popupFooterHorizontalClassName =
  'flex w-full flex-row gap-2 [&_button]:h-12 [&_button]:flex-1 [&_button]:rounded-16 [&_button]:text-base [&_button]:font-semibold';

/** Vertical Buttons — Primary full + Ghost · radius 16 */
export const popupFooterVerticalClassName =
  'flex w-full flex-col gap-2 [&_button]:h-12 [&_button]:w-full [&_button]:rounded-16 [&_button]:text-base [&_button]:font-semibold';

/** Primary — Grey-900 · radius 16 */
export const popupPrimaryButtonClassName = cn(
  'h-12 rounded-16 bg-[#131927] px-5 text-base font-semibold text-white',
  'hover:bg-[#131927]/90 focus-visible:ring-[#131927]',
);

/** Secondary — Grey-100 · radius 16 */
export const popupSecondaryButtonClassName = cn(
  'h-12 rounded-16 bg-ruda-grey-100 px-5 text-base font-semibold text-ruda-text-primary',
  'hover:bg-ruda-grey-100/80 border-0 shadow-none',
);

/** Ghost (vertical secondary) · radius 16 */
export const popupGhostButtonClassName = cn(
  'h-12 rounded-16 bg-transparent px-5 text-base font-semibold text-ruda-text-primary',
  'hover:bg-ruda-grey-50 border-0 shadow-none',
);
